import React, { Component } from 'react'
import ReactLoading from 'react-loading'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Container, Segment, Header } from 'semantic-ui-react'
import { send } from '../../../helpers/requests'
import Modules from '../common/modules'
import NoReports from '../no-reports'
import { actions as reports } from '../../../store/actions/reports'
import ActionsMetric from '../metrics/actions'
import BodyRebalanceList from '../metrics/body-rebalance-list'
import GsrHrvMetric from '../metrics/gsr-hrv'
import TagsMetric from '../metrics/tags'
// import WearingTimeMetric from '../metrics/wearing-time'

class FeelDataReports extends Component {
    constructor (props) {
        super(props)
        autoBind(this)
    }

    state = {
        metrics: {},
        bodyRebalanceMetrics: []
	}

    componentDidMount(){
        if (!this.props.reports || !this.props.currentReport) {
            this.fetchAvailableDataReports()
        }
        else if (!this.props.no_reports) {
            this.fetchWeeklyDataReports()
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.props.no_reports && this.props.currentReport !== prevProps.currentReport && this.props.currentReport) {
            this.setState({metrics: {}, bodyRebalanceMetrics: []})
            this.fetchWeeklyDataReports()
        }
    }

    fetchAvailableDataReports () {
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/reports/`
        })
            .then((response) => {
                let response_length = response.data["available_weeks"].length
                let newCurrentReport = response_length > 0 ? response.data["available_weeks"][response_length -1] : {}
                this.props.setNoReportsText(response.status)
                this.props.setNoReports(response_length === 0)
                this.props.setReports(response.data["available_weeks"])
                this.props.setCurrentReport(newCurrentReport)
            })
            .catch((error) => {
                var status_code = 500
                if (String(error).includes("eligible")){
                    status_code = 400
                }
                this.props.setNoReportsText(status_code)
                this.props.setNoReports(true)
                this.props.setReports({})
                this.props.setCurrentReport({})
                console.error('Failed to fetch available reports', error)
            })
        
    }

    fetchWeeklyDataReports () {
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/reports/${this.props.currentReport.report}`
        })
        .then((response) => {
            this.setState({ metrics: response.data["reports"],
            bodyRebalanceMetrics: response.data["body_rebalance_reports"] })
        })
        .catch((error) => {
            console.error('Failed to fetch metrics', error)
        })
    }

    render () {
        return (
            <Container className='feel-data-reports'>
                {this.props.no_reports ? 
                <NoReports
                    text={this.props.no_reports_text}
                /> : 
                this.props.reports && this.props.currentReport ?
                <React.Fragment>
                    <Segment className='intro'>
                        <Header as='h3'>
                            YOUR FEEL DATA REPORT
                        </Header>
                        <p>
                            This weekly report will provide you a deeper insight into your Feel data in order to help you better 
                            understand and monitor your progress and stay on track with the program.
                        </p>
                    </Segment>
                    <Modules/>
                </React.Fragment> : 
                <div className='performance-loader'>
                    <ReactLoading type='spin' color='#444'/>
                </div>}
                {this.props.no_reports ? <React.Fragment></React.Fragment> :
                Object.keys(this.state.metrics).length > 0 ?
                <React.Fragment>
                    <TagsMetric
                        tags_metric={this.state.metrics["tags.png"]}
                    />
                    <ActionsMetric
                        actions_metric={this.state.metrics["actions.png"]}
                    />
                    <GsrHrvMetric
                        gsr_metric={this.state.metrics["gsr.png"]}
                        hrv_metric={this.state.metrics["hrv.png"]}
                    />
                    {this.state.bodyRebalanceMetrics.length > 0 ?
                        <BodyRebalanceList
                            bodyRebalanceMetrics={this.state.bodyRebalanceMetrics}
                        /> : <React.Fragment></React.Fragment>
                    }
                </React.Fragment> :
                <div className='performance-loader'>
                    <ReactLoading type='spin' color='#444'/>
                </div>}                    
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userTokens: state.users.userTokens,
        pid: state.profiles.profile.pid,
        currentReport: state.reports.currentReport,
        reports: state.reports.reports,
        no_reports: state.reports.no_reports,
        no_reports_text: state.reports.no_reports_text
    }
}

const mapDispatchToProps = (dispatch) => {
    const _reports = bindActionCreators(reports, dispatch)
    return {
        setReports: _reports.setReports,
        setCurrentReport: _reports.setCurrentReport,
        setNoReports: _reports.setNoReports,
        setNoReportsText: _reports.setNoReportsText
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FeelDataReports))



// WEBPACK FOOTER //
// ./src/components/participant-feel-data-reports/feel-data-reports/index.js